// src/components/vehicle-management/employee-vehicle/EmployeeVehicleViewModal.tsx
import React from 'react';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import { EmployeeVehicle } from './types';

interface Props {
  show: boolean;
  onHide: () => void;
  assignment: EmployeeVehicle | null;
}

const EmployeeVehicleViewModal: React.FC<Props> = ({ show, onHide, assignment }) => {
  if (!assignment) return null;

  const employee = assignment.employee;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Vehicle Assign Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Card className="border-0 shadow-sm">
          <Card.Body>
            {/* Employee Information */}
            <h5 className="mb-3 ">Employee Information</h5>
            <Row className="mb-4">
              <Col md={6}>
                <div className="mb-2">
                  <strong>Full Name:</strong>
                  <p className="mb-0">{employee.employeeName}</p>
                </div>
                <div className="mb-2">
                  <strong>Employee Number:</strong>
                  <p className="mb-0">{employee.employeeNumber}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Email:</strong>
                  <p className="mb-0">{employee.email || '—'}</p>
                </div>
                <div className="mb-2">
                  <strong>Phone:</strong>
                  <p className="mb-0">{employee.phoneNumber || '—'}</p>
                </div>
                <div>
                  <strong>Status:</strong>{' '}
                  <span className={`badge bg-${employee.status === 'ACTIVE' ? 'success' : 'danger'} ms-2`}>
                    {employee.status}
                  </span>
                </div>
              </Col>
            </Row>

            {/* Vehicle Information */}
            <h5 className="mb-3 ">Vehicle Information</h5>
            <Row>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Number Plate:</strong>
                  <p className="mb-0 fw-bold fs-5">{assignment.vehicleNumberPlate}</p>
                </div>
                <div className="mb-2">
                  <strong>Color:</strong>
                  <p className="mb-0">{assignment.vehicleColor}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Vehicle Type:</strong>
                  <p className="mb-0">{assignment.vehicleTypeName}</p>
                </div>
                <div className="mb-2">
                  <strong>Vehicle Brand:</strong>
                  <p className="mb-0">{assignment.vehicleBrandName}</p>
                </div>
              </Col>
            </Row>

            {/* Additional Info */}
            <hr />
            <Row>
              <Col md={6}>
                <div>
                  <strong>Daily Usage Limit:</strong>
                  <p className="mb-0">{assignment.limitPerDay} times</p>
                </div>
              </Col>
              <Col md={6}>
                <div>
                  <strong>Assign Status:</strong>
                  <span className={`badge bg-${assignment.status === 'ACTIVE' ? 'success' : 'danger'} ms-2`}>
                    {assignment.status}
                  </span>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmployeeVehicleViewModal;